module.exports = __webpack_public_path__ + "img/Cloud error Icon - white.f3a548ff.svg";